/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.18 RHP_2SFB_grip.gltf -t -T 
Files: RHP_2SFB_grip.gltf [35.79KB] > C:\Users\Zac\rsenal-app\public\models\grips\RHP_2SFB\RHP_2SFB_grip-transformed.glb [602.6KB] (-1584%)
*/

import * as THREE from 'three'
import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { useMemo } from 'react'

type GLTFResult = GLTF & {
  nodes: {
    hand: THREE.SkinnedMesh
    ['DEF-forearmR']: THREE.Bone
  }
  materials: {}
}

//@ts-ignore
interface Props { props?: JSX.IntrinsicElements['group']}
export function Rhp2SFB({props}: Props) {
  //@ts-ignore
  const { scene } = useGLTF('/models/grips/RHP_2SFB_grip-transformed.glb') as GLTFResult
  const clonedScene = useMemo(() =>  {
    const clonedScene = SkeletonUtils.clone(scene)
    const bone = clonedScene.children[1] as THREE.Bone
    const hand = clonedScene.children[0] as THREE.SkinnedMesh
    return {hand: hand, bone: bone}
  }, [scene])


  return (
    <group scale={3.281} rotation={[Math.PI/2,0,0]} {...props} dispose={null}>
      <primitive object={clonedScene.bone} visible={false} />
      <skinnedMesh name="hand" 
        geometry={clonedScene.hand.geometry} 
        material={new THREE.MeshStandardMaterial({ color: '#999999'})} 
        skeleton={clonedScene.hand.skeleton} 
        morphTargetDictionary={clonedScene.hand.morphTargetDictionary} 
        morphTargetInfluences={clonedScene.hand.morphTargetInfluences} 
      />
    </group>
  )
}

useGLTF.preload('/models/grips/RHP_2SFB_grip-transformed.glb')
